"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GameController = void 0;
const gsap_1 = require("gsap");
const Logger_1 = require("@nolimitcity/slot-launcher/bin/utils/Logger");
const SpinEvent_1 = require("../spin/event/SpinEvent");
const ZeroBetManager_1 = require("../zerobet/ZeroBetManager");
const GameSetting_1 = require("../setting/GameSetting");
const EventHandler_1 = require("../event/EventHandler");
const GameEvent_1 = require("../event/GameEvent");
const WinPresentationEvent_1 = require("../winpresentation/event/WinPresentationEvent");
const ReelEvent_1 = require("../reel/event/ReelEvent");
const ServerEvent_1 = require("../server/event/ServerEvent");
const BalanceEvent_1 = require("../balance/event/BalanceEvent");
const ScreenEvent_1 = require("../screen/event/ScreenEvent");
const PresentationManager_1 = require("./presentations/PresentationManager");
const SlotGame_1 = require("../SlotGame");
const SlotApiEvent_1 = require("../slotapiadapter/event/SlotApiEvent");
const APIBetType_1 = require("@nolimitcity/slot-launcher/bin/interfaces/APIBetType");
class GameController {
    constructor(_config) {
        this.config = _config;
        this.initExternalControllers();
        // Flows
        this.SettingAPIEventFlow();
        this.SettingGameEventFlow();
    }
    /*
    * Add this to other file as performance booster.
    */
    fpsChanger(isPlaying) {
        const fps = isPlaying ? 144 : 30;
        gsap_1.TweenLite.ticker.fps(fps);
        gsap_1.TweenMax.ticker.fps(fps);
        gsap_1.TweenMax.ticker.useRAF(isPlaying);
        gsap_1.TweenLite.ticker.useRAF(isPlaying);
    }
    // Animation frame Fired triggers three times. Use this to remove one of them.
    OverFlowTickerRemoval() {
        const ticker = PIXI.Ticker.shared;
        ticker.autoStart = false;
        ticker.stop();
        gsap_1.TweenMax.ticker.useRAF(false);
        gsap_1.TweenLite.ticker.useRAF(false);
    }
    debugSpeedHandler() {
        Logger_1.Logger.warn("SpeedHack: Use Number 1-5.");
        document.addEventListener("keydown", function (e) {
            var keyCode = e.keyCode;
            switch (keyCode) {
                case 49: // 1
                    gsap_1.TweenMax.globalTimeScale(1);
                    break;
                case 51: // 2
                    gsap_1.TweenMax.globalTimeScale(2);
                    break;
                case 52: // 3
                    gsap_1.TweenMax.globalTimeScale(3);
                    break;
                case 53: // 4
                    gsap_1.TweenMax.globalTimeScale(4);
                    break;
                case 54: // 5
                    gsap_1.TweenMax.globalTimeScale(5);
                    break;
            }
        }, false);
    }
    // API Server
    SettingAPIEventFlow() {
        // Server-Events *
        EventHandler_1.EventHandler.addEventListener(this, ServerEvent_1.ServerEvent.INIT_DATA_PARSED, (event) => this.InitDataReceived(event.params[0]));
        EventHandler_1.EventHandler.addEventListener(this, ServerEvent_1.ServerEvent.GAME_DATA_PARSED, (event) => this.GameDataReceived(event.params[0]));
        // Bet-Events ** 
        EventHandler_1.EventHandler.addLastEventListener(this, BalanceEvent_1.BalanceEvent.BET, (event) => this.onBet(event.params[0]));
        // Intro/Restore Presentation-Event  ***
        EventHandler_1.EventHandler.addLastEventListener(this, ScreenEvent_1.ScreenEvent.GAME_READY, (event) => this.onGameReady());
        EventHandler_1.EventHandler.addLastEventListener(this, ScreenEvent_1.ScreenEvent.GAME_START, (event) => this.onGameStart());
    }
    // Game-SpinEvents
    SettingGameEventFlow() {
        EventHandler_1.EventHandler.addEventListener(this, SpinEvent_1.SpinEvent.SKIP, (event) => this.Skip());
        EventHandler_1.EventHandler.addEventListener(this, SpinEvent_1.SpinEvent.IDLE, (event) => this.Idle());
        EventHandler_1.EventHandler.addEventListener(this, SpinEvent_1.SpinEvent.BEFORE_START, (event) => this.PreStart());
        EventHandler_1.EventHandler.addEventListener(this, SpinEvent_1.SpinEvent.START, (event) => this.Start());
        EventHandler_1.EventHandler.addEventListener(this, ReelEvent_1.ReelEvent.ALL_REELS_SPIN_STARTED, (event) => this.Activated());
        EventHandler_1.EventHandler.addEventListener(this, SpinEvent_1.SpinEvent.STOP, (event) => this.Stop());
        EventHandler_1.EventHandler.addLastEventListener(this, SpinEvent_1.SpinEvent.STOPPED, (event) => this.Presentation());
        EventHandler_1.EventHandler.addEventListener(this, WinPresentationEvent_1.WinPresentationEvent.ALL_PRESENTATIONS_COMPLETED, (event) => this.checkZeroOrFinish());
        EventHandler_1.EventHandler.addEventListener(this, SlotApiEvent_1.SlotApiEvent.GAMBLE_DONE, (event) => this.checkZeroOrFinish());
    }
    // #ScreenEvent.GAME_READY
    onGameReady() {
        this.presentationManager.InitPresentations();
    }
    initExternalControllers() {
        //  Presentation controllers
        this.presentationManager = new PresentationManager_1.PresentationManager(this.config.PRESENTATIONS, this.config.checklog);
        // *******
        // Zero Controller
        this.zeroBetManager = new ZeroBetManager_1.ZeroBetManager();
        // ******
    }
    // #ServerEvent.INIT_DATA_PARSED
    // Initial data from server.
    InitDataReceived(data) {
        this.presentationManager.setInitData(data);
    }
    // #ScreenEvent.SKIP
    onGameStart() {
        // const eventToBePlayed:string = this.presentationManager.isRestore ? SpinEvent.RESTORE : SpinEvent.INTRO;
        // *******
        if (!!this.config.developerTools && GameSetting_1.GameSetting.isDevMode) {
            this.debugSpeedHandler();
        }
        if (!!this.config.optimization) {
            this.OverFlowTickerRemoval();
        }
        if (this.presentationManager.isRestore)
            this.presentationManager.playEvent(SpinEvent_1.SpinEvent.RESTORE, () => EventHandler_1.EventHandler.dispatchEvent(new GameEvent_1.GameEvent(SpinEvent_1.SpinEvent.STOPPED)));
        else
            EventHandler_1.EventHandler.dispatchEvent(new GameEvent_1.GameEvent(SpinEvent_1.SpinEvent.IDLE));
    }
    onBet(bet) {
        if (bet.type != APIBetType_1.APIBetType.GAMBLE_BET) {
            EventHandler_1.EventHandler.dispatchEvent(new GameEvent_1.GameEvent(SpinEvent_1.SpinEvent.BEFORE_START));
        }
    }
    // #SpinEvent.SKIP
    Skip() {
        if (!!this.config.checklog)
            Logger_1.Logger.logDev("Game: Skip");
        this.presentationManager.doSkip();
    }
    // Activated by BalanceEvent.BET.
    // #SpinEvent.BEFORE_START
    PreStart() {
        // Set the current mode to be used.
        if (!!this.config.optimization)
            this.fpsChanger(true);
        if (!!this.config.checklog)
            Logger_1.Logger.logDev("Game: PreStart");
        this.presentationManager.preStart();
        // Now when everything is done reseting, Send config to all Reels to start spin.
        EventHandler_1.EventHandler.dispatchEvent(new GameEvent_1.GameEvent(SpinEvent_1.SpinEvent.START));
    }
    // Init: #SpinEvent.START
    // event-return: ReelEvent.ALL_REELS_SPIN_STARTED
    Start() {
        if (!!this.config.checklog)
            Logger_1.Logger.logDev("Game: Start");
        // ReelEvent.ALL_REELS_SPIN_STARTED Sends an confirmation to API with SpinEvent.STARTED
        this.presentationManager.playEnd(() => this.presentationManager.playEvent(SpinEvent_1.SpinEvent.START, () => EventHandler_1.EventHandler.dispatchEvent(new GameEvent_1.GameEvent(ReelEvent_1.ReelEvent.ALL_REELS_SPIN_STARTED))));
    }
    //# Init:ReelEvent.ALL_REELS_SPIN_STARTED
    Activated() {
        if (!!this.config.checklog)
            Logger_1.Logger.logDev("Game: Engaged");
        // Tells the API that now the spin has been engaged and awaits server response.
        // SpinEvent.STARTED enables the quickstop function for a faster spin stop.
        EventHandler_1.EventHandler.dispatchEvent(new GameEvent_1.GameEvent(SpinEvent_1.SpinEvent.STARTED));
        // Try to stop the reels if we got GameData during Start/PreStart section.
        EventHandler_1.EventHandler.dispatchEvent(new GameEvent_1.GameEvent(SpinEvent_1.SpinEvent.STOP, false));
    }
    // API Server
    GameDataReceived(data) {
        // These can be called at any order
        if (!!this.config.checklog)
            Logger_1.Logger.logDev("Game: DataReceived");
        // Tell the presentation manager that the data has been parsed.
        this.presentationManager.setGameData(data);
        EventHandler_1.EventHandler.dispatchEvent(new GameEvent_1.GameEvent(SpinEvent_1.SpinEvent.STOP, false));
    }
    // #SpinEvent.STOP
    // This is being called when the GameData has been parsed AND "ALL_REELS_SPIN_STARTED" has been sent.
    Stop() {
        // Calls ReelEvent.ALL_REELS_STOP_SPIN
        // Tells the rest of the game module to stop spin.
        if (!!this.config.checklog)
            Logger_1.Logger.logDev("Game: Stop");
        /*
        *  For some reason, the SpinEvent.STOP is called a third time when we send SpinEvent.STOPPED.
        */
        // This Check Will Only Allow If Data and Start Is Done.
        if (!this.presentationManager.dataParsed || this.presentationManager.checkIsActivated(SpinEvent_1.SpinEvent.START))
            return;
        // To prevent the API endless eventCallback loop.
        if (this.presentationManager.activateAblePresentation(SpinEvent_1.SpinEvent.STOP))
            this.presentationManager.playEvent(SpinEvent_1.SpinEvent.STOP, () => EventHandler_1.EventHandler.dispatchEvent(new GameEvent_1.GameEvent(SpinEvent_1.SpinEvent.STOPPED)));
    }
    // #SpinEvent.STOPPED
    Presentation() {
        if (!!this.config.checklog)
            Logger_1.Logger.logDev("Game: Presentation");
        this.presentationManager.playEvent(WinPresentationEvent_1.WinPresentationEvent.WIN_PRESENTATIONS_STARTED, () => {
            console.log("All presentations complete");
            EventHandler_1.EventHandler.dispatchEvent(new GameEvent_1.GameEvent(WinPresentationEvent_1.WinPresentationEvent.ALL_PRESENTATIONS_COMPLETED));
        });
    }
    // #WinPresentationEvent.ALL_PRESENTATIONS_COMPLETED
    checkZeroOrFinish() {
        if (!!this.config.checklog)
            Logger_1.Logger.logDev("Game: checkZeroOrFinish");
        // Result Presentations are now done and ready to check if there is a zeroBet.
        EventHandler_1.EventHandler.dispatchEvent(new GameEvent_1.GameEvent(SpinEvent_1.SpinEvent.DONE));
        let finishGameRound = !this.zeroBetManager.tryPlayZeroBet();
        if (SlotGame_1.SlotGame.gamblePlugin && SlotGame_1.SlotGame.gamblePlugin.hasGamble()) {
            SlotGame_1.SlotGame.gamblePlugin.startGamble();
            finishGameRound = false;
        }
        if (finishGameRound) {
            EventHandler_1.EventHandler.dispatchEvent(new GameEvent_1.GameEvent(SpinEvent_1.SpinEvent.IDLE));
        }
    }
    // #SpinEvent.IDLE
    Idle() {
        this.presentationManager.playEvent(SpinEvent_1.SpinEvent.IDLE, () => this.finishGameRound());
        if (!!this.config.optimization)
            this.fpsChanger(false);
    }
    finishGameRound() {
        Logger_1.Logger.logDev("Game Round Finished!");
        // Tells the api the round is finished.
        EventHandler_1.EventHandler.dispatchEvent(new GameEvent_1.GameEvent(SpinEvent_1.SpinEvent.FINISH));
    }
}
exports.GameController = GameController;
//# sourceMappingURL=GameController.js.map